/**
 * apiConstants.js
 * Talkroute
 *
 * Created by Vel Genov on 6/13/19
 * Copyright (c) 2019 Talkroute. All right reserved.
 */
import { AudioTypes } from "@models/AudioFiles.models";

/**
 * A collection of constants used with when connecting
 * to the Talkroute API and push notification service
 */

const apiConstants = () => {
  return {
    SENDER_ID: "1092546151128", // Firebase Cloud Messaging Sender ID used for the push notification service
    // Swap out with the line before to use the production API
    endpoints: {
      REQUEST_TOKEN: "oauth-login",
      REFRESH_TOKEN: "oauth-refresh",
      LOGOUT: "auth/logout",
      REGISTER_NOTIFICATIONS: (deviceType: string) =>
        `v1/${deviceType}/device/push/registration`,
      GET_CALL_HISTORY: (page?: number) => `v1/call-history?page=${page ?? 1}`,
      callhistory: {
        BASE: "v2/call-history"
      },
      DELETE_CALL_RECORD_V2: (recordId: string | number) => `/v2/call-history/${String(recordId)}/call-recording`,
      account: {
        BASE_URL: "/v2/accounts",
        BILLING: (userId: string) => `/v2/accounts/${userId}/billing`,
        PERMITTED_FEATURES: (userId: string) => `/v2/accounts/${userId}/permitted-features`
      },
      contacts: {
        BASE_URL: "/v2/contacts",
        ADD_PHONE_NUMBER: (id: string) => `/v2/contacts/${id}/phone-numbers`,
        MODIFY_PHONE_NUMBER: (contactId: string, numberId: string) => `/v2/contacts/${contactId}/phone-numbers/${numberId}`,
        
      },
      user: {
        BASE_URL: "/v2/users",
        SINGLE_URL: "/user",
      },
      plans: {
        BASE_URL: "/v2/plans",
        GET_SINGLE_PLAN: (planId: string) => `/v2/plans/${planId}`
      },
      device: {
        DELETE: deviceType => `/v2/devices/${deviceType}`,
      },
      voicemail: {
        VOICEMAIL_BASE: "v1/voicemails",
        GET_VOICEMAILS: "v1/voicemails",
        GET_VOICEMAIL_BOXES: "v1/voicemail/boxes",
        AUDIO_URL: "audio-url",
        MARK_AS_READ: "read",
        MARK_AS_UNREAD: "unread",
      },
      voicemailv2: {
        VOICEMAILBOX_BASE: "/v2/voice-mailboxes",
      },
      menuv2: {
        BASE: "/v2/menus",
      },
      hoursofoperationv2: {
        BASE: "/v2/hours",
        SETTINGS: "/v2/hours/settings"
      },
      audiofilesv2: {
        AUDIOFILES_BASE: "/v2/audio-files",
        GET_AUDIO_FILES: (
          page: number,
          size: number,
          type: AudioTypes | null,
        ) =>
          `/v2/audio-files?page=${page}&pageSize=${size}${
            type ? "&type=" + type : ""
          }`,
      },
      transfercodesv2: {
        BASE: "/v2/transfer-codes",
        GET_TRANSFER_CODES: (params: URLSearchParams) => `/v2/transfer-codes?${params}`
      },
      extensionsv2: {
        BASE: "/v2/extensions"
      },
      voicemessagesv2: {
        BASE: "/v2/voice-messages",
      },
      moxtrav2: {
        GET_ACCESS_TOKEN: (userId: string) => `/v2/users/${userId}/moxtra-token`,
        GET_GUEST_ACCESS_TOKEN: `/users/0/moxtra-token`,
        BASE: `/v2/moxtra-meetings`,
        SEND_EMAIL_INVITATION: (sessionKey: string) => `/v2/moxtra-meetings/${sessionKey}/invitees`,
      },
      forwardingnumbersv2: {
        BASE: "/v2/forwarding-numbers"
      },
      conversations: {
        CONVERSATIONS_BASE: "v1/messages/text/threads",
        GET_SINGLE_CONVERSATION: "v1/messages/text/thread",
      },
      virtualNumbers: {
        BASE: "/v2/virtual-numbers",
        FOR_MESSAGING: "/v2/virtual-numbers?couldBeUsedForMessaging=1",
        UPDATE_NUMBER: (id: string) => `/v2/virtual-numbers/${id}`,
        EMAIL_SUBSCRIBERS: (id: string) => `/v2/virtual-numbers/${id}/email-subscribers`
      },
      messages: {
        MESSAGES_BASE: "v1/messages/text/thread",
        MARK_AS_READ: "read",
        MARK_AS_UNREAD: "unread",
        // /messages/text/message/abad7212-eacf-11e9-b8b1-56000258b29a/attachment/abb42e02-eacf-11e9-b8b1-56000258b29a
        MESSAGE_ATTACHMENT_BASE: "v1/messages/text/message",
        MESSAGE_ATTACHMENT: "attachment",
      },
      PHONE_NUMBERS: "v1/talkroute-numbers",
      BLOCK_CALL: "v1/account/blocked-numbers",
      BLOCK_CALL_V2: (id: number) => `/v2/accounts/${id}/blocked-numbers`,
      USER_PERMISSIONS: "v1/account/user/permissions",
    },
    timeBeweenFetch: {
      // Values are in seconds
      CALL_HISTORY: 30,
      VOICEMAILS: 30,
    },
    voicemailFileSettings: {
      VOICEMAIL_USER_FOLDER: "/Voicemails/",
      VOICEMAIL_FILE_EXTENSION: "oga",
    },
    textMessageAttachmentSettings: {
      ATTACHMENT_USER_FOLDER: "/Attachments/",
      ATTACHMENT_FILE_NAME: "Picture",
      MAX_ATTACHMENT_SIZE: 1000000, // 1MB in bytes
    },
    errors: {
      VOICEMAIL_FILE_NOT_FOUND: "Not Found",
    },
    quaryParam: "?",
    andQueryParam: "&",
    limit: "limit=",
    offset: "offset=",
    lastSeenCreatedAtMicroSeconds: "last_seen_created_at_micro_seconds=",
    since: "since=",
    before: "before=",
    firstMessageBefore: "firstMessageBefore=",
    firstMessageAfter: "firstMessageAfter=",
    talkrouteNumber: "talkrouteNumber=",
    minMessagesCount: "minMessagesCount=",
    maxMessagesCount: "maxMessagesCount=",
  };
};

export default apiConstants;
